import { handleResponse, nextFormDataApi, nextJsonApi } from '@/API/core';

const uploadFiles = {
  uploadCSVFile: async (body: any) => {
    let response = null;
    try {
      response = await nextJsonApi.post('/upload-files/upload', body);
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  getSuperBillColumns: async (body: any) => {
    let response = null;
    try {
      response = await nextJsonApi.post('/upload-files/fetch', body);
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default uploadFiles;
